import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from './lib/auth'
import { initAnalytics, track } from './lib/analytics'
import { BootPicker } from './components/BootPicker'

// Before render, so ?internal= is read and stripped from the address bar before
// anything else runs. PostHog itself loads later, after first paint, and the
// initial $pageview goes out when it does (see analytics.ts, 2026-09-23).
initAnalytics()

// The first-visit picker already painted from index.html (bootPicker in
// vite.config.ts). Hydrate it where it stands, before App renders, so React
// adopts those nodes instead of painting new ones - see lib/onboardingBridge.
// When the shell decided not to show it, drop the markup; App then knows by its
// absence that there is no picker to open.
const boot = document.getElementById('boot-picker')
if (boot && !boot.hidden) {
  hydrateRoot(
    boot,
    <StrictMode>
      <BootPicker container={boot} />
    </StrictMode>,
    {
      // A mismatch means React threw the static nodes away and rendered its
      // own, which still works but loses the LCP win. Reported so it gets seen.
      onRecoverableError: (error) => {
        console.warn('boot picker hydration', error)
        track('boot_picker_mismatch', { message: String(error).slice(0, 200) })
      },
    },
  )
} else {
  boot?.remove()
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
)
